import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, CircularProgress, Drawer, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "./styles";
import { icons } from "../../../../../../../../utils/icons";
import { useTranslation } from "react-i18next";
import { VIEW_TYPES } from "../../types/ViewTypes";
import { useGetData } from "../../hooks/useGetData";
import format from "date-fns/format";
import es from "date-fns/locale/es";
import { useEvidences } from "../../../../../../../../hooks/evidences/useEvidences";
import EvidenceDetail from "../../../../../../../actionPlans/pages/form/components/evidenceDetail";
import StarIcon from '@mui/icons-material/Star';
import { ActionDrawer } from "../../../../../../../../components/ActionDrawer";
import { useEvidenceDownload } from "../../../../../../../calendar/pages/detail/hooks";
import { Constants } from "../../../../../../../../utils/constants";
import { AnswerTypeHistory } from "../../enums/answerType";

export const SeeDetail = ({ onAttend, quoteId }) => {
    const styles = useStyles();
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const { id } = useParams();
    const { data, getHistorial } = useGetData({ id });
    useEffect(() => {
        getHistorial();
    }, [id]);
    const { historial, left } = data || {};

    const selectedItem = historial?.items?.find(item => item.id === quoteId);
    const nextItem = historial?.items?.find((item, index) => {
        const currentIndex = historial.items.findIndex(i => i.id === quoteId);
        return index === currentIndex + 1;
    });
    const { evidences, existEvidences } = useEvidences({
        evidencesResponse: selectedItem?.type == AnswerTypeHistory.SOLUTION ? selectedItem?.evidencesAnswer : selectedItem?.evidencesQuote || selectedItem?.evidencesAnswer,
        manualValue: false,
    });
    const { disable: isDownloading, /* openSnackbar, handleCloseSnackbar, */ downloadEvidences, } = useEvidenceDownload('evidencias', selectedItem?.type == AnswerTypeHistory.SOLUTION ? selectedItem?.evidencesAnswer : selectedItem?.evidencesQuote || selectedItem?.evidencesAnswer);
    const isSolutionRejected = (selectedItem?.type === AnswerTypeHistory.SOLUTION || selectedItem?.type === AnswerTypeHistory.MANAGE_SOLUTION) && selectedItem?.statusIdAnswer === 13
    const isApprove = selectedItem?.type === AnswerTypeHistory.FINISH || (selectedItem?.type === AnswerTypeHistory.SOLUTION && selectedItem?.statusIdAnswer === 19);
    const rating = left?.rating;

    const isSolution = selectedItem?.type === AnswerTypeHistory.MANAGE_SOLUTION ||
        (selectedItem?.type === AnswerTypeHistory.SOLUTION &&
            (selectedItem?.statusIdAnswer === 19 || selectedItem?.statusIdAnswer === 13));

    const { evidences: evidencesSolution, existEvidences: existEvidencesSolution } = useEvidences({
        evidencesResponse: isSolution && isSolutionRejected
            ? selectedItem?.evidencesRejectionAnswer
            : selectedItem?.evidencesApprovalAnswer,
        manualValue: false,
    });
    
    const { disable: isDownloadingSolution, /* openSnackbar, handleCloseSnackbar, */ downloadEvidences: downloadSolution, } = useEvidenceDownload('evidencias', isSolution && isSolutionRejected ? selectedItem?.evidencesRejectionAnswer : selectedItem?.evidencesApprovalAnswer);

    const formattedDate = !isSolution ?
    selectedItem?.dateUploadQuote
        ? format(new Date(selectedItem.dateUploadQuote), Constants.dateFormatGeneral3, { locale: es })
        : t("reportFolio.detail.general.noDateAvailable")
        : selectedItem?.dateUploadSolution
        ? format(new Date(selectedItem.dateUploadSolution), Constants.dateFormatGeneral3, { locale: es })
        : t("reportFolio.detail.general.noDateAvailable")
        ;

    const formattedDateAnswer = selectedItem?.dateRequestManagement
        ? format(new Date(selectedItem.dateRequestManagement), Constants.dateFormatGeneral3, { locale: es })
        : t("reportFolio.detail.general.noDateAvailable");

    const provider = selectedItem?.usersAssings?.[0]
        ? `${selectedItem.usersAssings[0].firstName} ${selectedItem.usersAssings[0].lastName}`
        : t("reportFolio.detail.general.noAssignedUser");

    const SendBy = !isSolution
        ? selectedItem?.quote?.createdByUserQuote
            ? `${selectedItem.quote.createdByUserQuote.firstName} ${selectedItem.quote.createdByUserQuote.lastName}`
            : t("reportFolio.detail.general.noAssignedUser")
        : selectedItem?.userUploadAnswer
            ? `${selectedItem.userUploadAnswer.firstName} ${selectedItem.userUploadAnswer.lastName}`
            : t("reportFolio.detail.general.noAssignedUser");

    const ResponseBy = !isSolution
        ? selectedItem?.userReviewerQuote
            ? `${selectedItem.userReviewerQuote.firstName} ${selectedItem.userReviewerQuote.lastName}`
            : t("reportFolio.detail.general.noAssignedUser")
        : selectedItem?.userReviewerAnswer
            ? `${selectedItem.userReviewerAnswer.firstName} ${selectedItem.userReviewerAnswer.lastName}`
            : t("reportFolio.detail.general.noAssignedUser");

    //userReviewerAnswer

    const commentUpload = selectedItem?.commentUpload;
    const solutionComment = selectedItem?.descriptionAnswer
    //DescriptionAnswer
    const reasonOfRejectionQuote = selectedItem?.reasonOfRejectionQuote;
    const commentApprovalQuote = selectedItem?.commentApprovalQuote;
    const commentApprovalSolution = selectedItem?.commentApprovalAnswer;
    const reasonOfRejectionAnswer = selectedItem?.reasonOfRejectionAnswer

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <Typography sx={styles.title} fontWeight={'bold'}>
                {isSolution || isSolutionRejected ? t("reportFolio.detail.general.solutionDetail") : t("reportFolio.detail.general.seeQuotationDetail")}
            </Typography>

            <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={styles.grid} className="brdLft">
                    <Box>
                        <Typography variant="body2" fontWeight={'bold'}>
                            {isSolution || isSolutionRejected ? t("reportFolio.detail.general.solutionSent") : t("reportFolio.detail.general.quotationSent")}
                        </Typography>
                        {isSolution ? (
                            <Typography variant="body2" color="textSecondary"
                            sx={styles.desbord}
                            >
                                {solutionComment ? solutionComment : "No hay comentario."}
                            </Typography>
                        ) : <Typography variant="body2" color="textSecondary" sx={styles.desbord}>
                            {commentUpload ? commentUpload : "No hay comentario."}
                        </Typography>}


                    </Box>
                    <Box sx={styles.informationAndEvidences}>
                        <Box>
                            <Typography variant="body2" fontWeight={'bold'}>{t("reportFolio.detail.general.information")}</Typography>
                            <Typography variant="body2" color="textSecondary">{t("reportFolio.detail.general.generatedOn", { fecha: formattedDate })}</Typography>
                            <Typography variant="body2" color="textSecondary">{t("reportFolio.detail.general.generatedBy", { provider: SendBy })}</Typography>
                        </Box>
                        <Box>
                            <Typography variant="body2" fontWeight={'bold'}>{t("reportFolio.detail.general.evidencesDetail")}</Typography>
                            <ActionDrawer
                                title="EVIDENCIAS"
                                body={<>
                                    <Box sx={styles.mainContainer}>
                                        <Box sx={styles.bodyContainer}>
                                            <EvidenceDetail
                                                existEvidences={existEvidences}
                                                evidences={{
                                                    image: evidences?.images,
                                                    comment: evidences?.comments,
                                                    documents: evidences?.documents,
                                                    video: evidences?.video,
                                                    sign: evidences?.sign
                                                }}
                                            />
                                        </Box>
                                        <Box>
                                            <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                                        </Box>
                                    </Box>
                                </>}
                            >
                                {
                                    ({ openDrawer }) =>
                                        <Tooltip title="">
                                            <IconButton
                                                onClick={() => { openDrawer() }}
                                                sx={styles.clip}
                                                disabled={!existEvidences}
                                            >
                                                {icons("clip")}
                                            </IconButton>
                                        </Tooltip>
                                }
                            </ActionDrawer>
                        </Box>

                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={styles.grid}>
                    <Box>
                        <Typography variant="body2" fontWeight={'bold'} sx={styles.desbord}>
                            {reasonOfRejectionQuote || isSolutionRejected
                                ? t("reportFolio.detail.general.rejected")
                                : t("reportFolio.detail.general.approved")}
                        </Typography>
                        {isSolution ? (
                            isSolutionRejected ? (
                                <Typography variant="body2" color="textSecondary" sx={styles.desbord} >
                                    {reasonOfRejectionAnswer}
                                </Typography>
                            ) : (
                                <Typography variant="body2" color="textSecondary" sx={styles.desbord} >
                                    {commentApprovalSolution}
                                </Typography>
                            )
                        ) : (
                            <Typography variant="body2" color="textSecondary" sx={styles.desbord} >
                                {reasonOfRejectionQuote ? reasonOfRejectionQuote : commentApprovalQuote}
                            </Typography>
                        )}

                    </Box>
                    <Box sx={styles.informationAndEvidences}>
                        <Box>
                            <Typography variant="body2" fontWeight={'bold'}>{t("reportFolio.detail.general.information")}</Typography>
                            <Typography variant="body2" color="textSecondary">{t("reportFolio.detail.general.generatedOn", { fecha: formattedDateAnswer })}</Typography>
                            <Typography variant="body2" color="textSecondary">{t("reportFolio.detail.general.generatedBy", { provider: ResponseBy })}</Typography>
                        </Box>
                        {isSolution || isSolutionRejected || isApprove ? <Box>
                            <Typography variant="body2" fontWeight={'bold'}>{t("reportFolio.detail.general.evidencesDetail")}</Typography>
                            <ActionDrawer
                                title="EVIDENCIAS"
                                body={<>
                                    <Box sx={styles.mainContainer}>
                                        <Box sx={styles.bodyContainer}>
                                            <EvidenceDetail
                                                existEvidences={existEvidencesSolution}
                                                evidences={{
                                                    image: evidencesSolution?.images,
                                                    comment: evidencesSolution?.comments,
                                                    documents: evidencesSolution?.documents,
                                                    video: evidencesSolution?.video,
                                                    sign: evidencesSolution?.sign
                                                }}
                                            />
                                        </Box>
                                        <Box>
                                            <Button variant='text_primary_small' onClick={downloadSolution} disabled={isDownloadingSolution}>{t('schedule.buttons.downloadEvidence')}</Button>
                                        </Box>
                                    </Box>
                                </>}
                            >
                                {
                                    ({ openDrawer }) =>
                                        <Tooltip title="">
                                            <IconButton
                                                onClick={() => { openDrawer() }}
                                                sx={styles.clip}
                                                disabled={!existEvidencesSolution}
                                            >
                                                {icons("clip")}
                                            </IconButton>
                                        </Tooltip>
                                }
                            </ActionDrawer>
                        </Box> : null}

                    </Box>
                    {isSolution && rating?.rating ? (
                        <Box>
                            <Box>
                                <Typography variant="body2" fontWeight={'bold'}>{t("reportFolio.detail.general.survey")}</Typography>
                                <Box display="flex" flexDirection="column">
                                    {rating?.rating && (
                                        <>
                                            <Typography variant="body1" color="textSecondary">
                                                {rating.ratingQuestion}
                                            </Typography>

                                            <Box display="flex">
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <Typography
                                                        key={star}
                                                        component="span"
                                                        sx={{
                                                            color: star <= rating.rating ? '#FFD700' : '#E0E0E0',
                                                            fontSize: '24px'
                                                        }}
                                                    >
                                                        <StarIcon />
                                                    </Typography>
                                                ))}
                                            </Box>

                                            {rating.ratingComment && (
                                                <Typography
                                                    variant="body2"
                                                    sx={{ '&.MuiTypography-root': { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }, }}
                                                >
                                                    {rating.ratingComment}
                                                </Typography>
                                            )}
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    ) : <></>}
                </Grid>
            </Grid>

            <Box sx={styles.button}>
                <Button onClick={() => { onAttend(VIEW_TYPES.TAB_SWITCHER) }}>{t("general.cancel")}</Button>
            </Box>

        </Box >
    );
};
